<template>
  <!-- @click.prevent to prevent submit on next/prev/month interaction -->
  <div
    id="range-datepicker"
    ref="range-datepicker"
    class="emd-date-picker _inline"
    @click.prevent
  >
    <div
      class="eu-display_flex eu-zindex_4 eu-position_relative eu-align-items_end"
    >
      <div
        class="emd-form-group eu-no-padding eu-mr_2 eu-basis_12 eu-shrink_1"
        data-children-count="1"
      >
        <label
          for="since"
          class="emd-text _type_label _color_primary _size_tiniest"
          >{{ $t('since') }}</label
        >
        <input-date
          aria-autocomplete="off"
          class="_size_small"
          :locale="locale"
          :value="startModel"
          id="range-start"
          ref="range-start"
          name="start"
        />
      </div>
      <div
        class="emd-form-group eu-no-padding eu-basis_12 eu-shrink_1"
        data-children-count="1"
      >
        <label
          for="until"
          class="emd-text _type_label _color_primary _size_tiniest"
          >{{ $t('until') }}</label
        >
        <input-date
          aria-autocomplete="off"
          class="_size_small"
          :locale="locale"
          :value="endModel"
          id="range-end"
          ref="range-end"
          name="end"
        />
      </div>
      <div class="eu-ml_2">
        <button
          type="submit"
          class="emd-btn _size_small _color_primary"
          @click="submit"
        >
          <i class="uil uil-search" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import InputDate from './InputDate'
import { Datepicker, DateRangePicker } from 'vanillajs-datepicker'
import * as pt from 'vanillajs-datepicker/js/i18n/locales/pt-BR.js'

export default {
  name: 'RangeDatepicker',
  components: {
    InputDate
  },
  props: {
    locale: {
      type: String,
      required: false,
      default: 'pt-BR'
    },
    start: {
      type: [Object, String],
      required: false
    },
    end: {
      type: [Object, String],
      required: false
    },
    minDate: {
      type: Date,
      default: null
    }
  },
  data () {
    return {
      rangeDatePicker: {},
      startDate: {},
      endDate: {},
      format: this.locale === 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy',
      startModel: this.start,
      endModel: this.end,
      inputStart: null,
      inputEnd: null
    }
  },
  watch: {
    start (value) {
      if (value !== this.startModel) {
        this.startModel = value
      }
    },
    end (value) {
      if (value !== this.endModel) {
        this.endModel = value
      }
    }
  },
  methods: {
    submit () {
      this.$emit('onSubmit')
    }
  },
  mounted () {
    Object.assign(Datepicker.locales, pt.default)
    const options = {
      showOnFocus: true,
      autohide: true,
      language: this.locale === 'en-US' ? 'en' : 'pt-BR',
      format: this.format,
      container: '#range-datepicker',
      orientation: 'left bottom',
      maxDate: new Date(),
      minDate: this.minDate
    }
    const rangeDatepickerElement = this.$refs['range-datepicker']
    this.rangeDatePicker = new DateRangePicker(rangeDatepickerElement, options)
    this.inputStart = document.getElementById('range-start')
    this.inputEnd = document.getElementById('range-end')
    this.inputStart.addEventListener('changeDate', event => {
      if (this.rangeDatePicker.getDates('dd/mm/yyyy')[0]) {
        this.startDate = {
          name: 'sinceDate',
          value: this.rangeDatePicker
            .getDates('dd/mm/yyyy')[0]
            .split('/')
            .reverse()
            .join('-'),
          text: this.rangeDatePicker.getDates(this.format)[0]
        }
        this.inputEnd.focus()
        this.$emit('changeDate', this.startDate)
      }
    })
    this.inputEnd.addEventListener('changeDate', event => {
      if (this.rangeDatePicker.getDates('dd/mm/yyyy')[1]) {
        this.endDate = {
          name: 'untilDate',
          value: this.rangeDatePicker
            .getDates('dd/mm/yyyy')[1]
            .split('/')
            .reverse()
            .join('-'),
          text: this.rangeDatePicker.getDates(this.format)[1]
        }
        this.inputStart.focus()
        this.$emit('changeDate', this.endDate)
      }
    })
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "since": "De:",
    "until": "Até:"
  },
  "en-US": {
    "since": "Since:",
    "until": "Until:"
  }
}
</i18n>
<style>
.emd-date-picker._inline .datepicker-dropdown {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
}
.emd-date-picker._inline .datepicker-dropdown .datepicker-picker {
  box-shadow: none !important;
}
</style>
